/*
 * Copyright Higharc Inc. 2020
 */

export const normalPackingHelpersGLSL = `
#if !defined(NORMAL_PACKING_HELPERS_GLSL_HIGHARC)
#define NORMAL_PACKING_HELPERS_GLSL_HIGHARC 1
float unpackNormalRGToHalf( vec2 v ) {
  float norm = v.x + (v.y - 0.5) / 255.;
  return norm * 2.0 - 1.0;
}

float unpackNormalRGToHalfAndZSign( vec2 v, out float zSign ) {
  zSign = sign(v.x - 127./255.);
  float norm = (abs(v.x - 127./255.) * 255. - 1.)/126. + (v.y - 0.5) / 126.;
  return norm * 2.0 - 1.0;
}

vec3 unpackRGBAToNormal( const in vec4 packedNormal ) {
  float zSign = 1.;
  vec2 unpackedXY = clamp( vec2( unpackNormalRGToHalfAndZSign( packedNormal.xy, zSign ), unpackNormalRGToHalf( packedNormal.zw ) ), -1.0, 1.0 );
  float z = sqrt( max(1.0 - unpackedXY.x * unpackedXY.x - unpackedXY.y * unpackedXY.y, 0.0) ) * zSign;
  return vec3( unpackedXY, z );
}

vec2 packNormalHalfToRG( float f ) {
  f = f * 0.5 + 0.5;
  float roundedToNearest = floor( f * 255. + 0.5 ) / 255.;
  float offsetFromNearest = (f - roundedToNearest) * 255. + 0.5;
  return vec2(roundedToNearest, offsetFromNearest);
}

vec2 packNormalHalfAndZSignToRG( float f, float z ) {
  f = f * 0.5 + 0.5;
  float roundedToNearest = floor( f * 126. + 0.5 ) / 126.;
  float offsetFromNearest = ( f - roundedToNearest ) * 126. + 0.5;
  return vec2( ( z >= 0. ? 1. : -1. ) * (roundedToNearest * 126. + 1.) / 255. + 127./255., offsetFromNearest );
}

vec4 packNormalToRGBA( const in vec3 normal ) {
  return vec4( packNormalHalfAndZSignToRG(normal.x, normal.z), packNormalHalfToRG(normal.y) );
}
#endif
`;
